import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isNumber, addEventListener, debounce } from '@cloud-sn/v-utils';
import { buildComponentName } from '../utils';
export default {
  name: buildComponentName('Affix'),
  props: {
    prefixCls: {
      type: String,
      default: 'ux-affix'
    },
    getTarget: {
      type: Function,
      default: function _default() {
        return window;
      }
    },
    offsetBottom: {
      type: Number,
      default: null
    },
    offsetTop: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      affixStyle: null,
      events: []
    };
  },
  computed: {
    classes: function classes() {
      var prefixCls = this.prefixCls,
          affixStyle = this.affixStyle;
      return _defineProperty({}, prefixCls, affixStyle);
    },
    styles: function styles() {
      var affixStyle = this.affixStyle;
      return affixStyle ? _objectSpread({
        position: 'fixed'
      }, affixStyle) : null;
    },
    isAffixTop: function isAffixTop() {
      var offsetTop = this.offsetTop;
      return isNumber(offsetTop);
    },
    isAffixBottom: function isAffixBottom() {
      var offsetBottom = this.offsetBottom;
      return isNumber(offsetBottom);
    },
    target: function target() {
      return this.getTarget();
    },
    isWin: function isWin() {
      var target = this.target,
          isWindow = this.isWindow;
      return isWindow(target);
    }
  },
  mounted: function mounted() {
    var target = this.target,
        updatePosition = this.updatePosition,
        events = this.events;
    updatePosition();
    events.push(addEventListener(target, 'scroll', debounce(updatePosition)));
    events.push(addEventListener(target, 'resize', debounce(updatePosition)));
  },
  beforeDestroy: function beforeDestroy() {
    var events = this.events;
    events.forEach(function (v) {
      return v && v.remove();
    });
  },
  methods: {
    isWindow: function isWindow(target) {
      return target.window === window;
    },
    getTargetRect: function getTargetRect() {
      var target = this.target,
          isWindow = this.isWindow;

      if (!isWindow(target)) {
        var rect = target.getBoundingClientRect();
        return {
          top: rect.top,
          left: rect.left,
          bottom: rect.bottom,
          right: rect.right,
          width: rect.width,
          height: rect.height,
          cw: target.clientWidth,
          ch: target.clientHeight
        };
      }

      return {
        left: 0,
        top: 0,
        // excludes scrollbar
        cw: document.documentElement.clientWidth,
        ch: document.documentElement.clientHeight
      };
    },
    updatePosition: function updatePosition() {
      var $el = this.$el,
          affixRef = this.$refs.affixRef,
          affixStyle = this.affixStyle,
          target = this.target,
          getTargetRect = this.getTargetRect,
          offsetTop = this.offsetTop,
          offsetBottom = this.offsetBottom,
          isAffixTop = this.isAffixTop,
          isAffixBottom = this.isAffixBottom,
          isWin = this.isWin;
      var targetRect = getTargetRect();
      var elemRect = $el.getBoundingClientRect();
      var affixHeight = affixRef.offsetHeight; // top border width of target

      var targetClientTop = isWin ? 0 : target.clientTop;
      var top = isWin ? elemRect.top : elemRect.top - targetRect.top - targetClientTop;
      var style = null;

      if (isAffixTop && top < offsetTop) {
        style = {
          position: 'fixed',
          top: "".concat(targetRect.top + offsetTop + targetClientTop, "px"),
          left: "".concat(elemRect.left, "px"),
          width: "".concat(elemRect.width, "px")
        };
      } else if (isAffixBottom && top + affixHeight + offsetBottom > targetRect.ch) {
        var bottom = isWin ? 0 : document.documentElement.clientHeight - targetRect.top - targetClientTop - targetRect.ch;
        style = {
          position: 'fixed',
          bottom: "".concat(bottom + offsetBottom, "px"),
          left: "".concat(elemRect.left, "px"),
          width: "".concat(elemRect.width, "px")
        };
      }

      if (affixStyle && !style || !affixStyle && style) {
        this.$emit('change', !!style);
      }

      if (style) {
        $el.style.height = "".concat(affixHeight, "px");
      } else {
        $el.style.cssText = '';
      }

      this.affixStyle = style;
    }
  },
  render: function render() {
    var h = arguments[0];
    var $slots = this.$slots,
        $attrs = this.$attrs,
        classes = this.classes,
        styles = this.styles;
    var slotDefault = $slots.default;
    return h("div", {
      "attrs": _objectSpread({}, $attrs)
    }, [h("div", _mergeJSXProps([{}, {
      class: classes,
      style: styles,
      ref: 'affixRef'
    }]), [slotDefault])]);
  }
};